import { HsaFsaInlineLogo } from '@jouzen/ecom-components/icons/HsaFsaInlineLogo';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';

import RichText from '@/app/components/RichText';
import useUsaOnly from '@/app/hooks/useUsaOnly';

const LogoComponent = () => (
  <HsaFsaInlineLogo
    className="inline-block -translate-y-px"
    color="currentColor"
  />
);

interface HsaFsaIconProps {
  readonly inverted?: boolean;
  readonly className?: string;
}

const HsaFsaIcon = ({ inverted = false, className }: HsaFsaIconProps) => {
  const isUS = useUsaOnly();
  const textColor = inverted ? 'text-sandstone-500' : 'text-white';

  if (isUS) {
    return (
      <div
        className={cx('flex flex-row items-center justify-center', className)}
        data-cy="hsa-fsa-icon"
      >
        <Typography className={textColor} weight="bold">
          <RichText
            messageKey="hsa_fsa_eligible_line_item"
            tValues={{
              logo: LogoComponent,
            }}
          />
        </Typography>
      </div>
    );
  } else {
    return <></>;
  }
};

export default HsaFsaIcon;
